var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, OnDestroy, ElementRef } from '@angular/core';
import { FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { PaymentService } from '../payment.service';
import { takeWhile, debounceTime, map, distinctUntilChanged, startWith, tap } from 'rxjs/operators';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { INDRAObservatoryService } from '@ibe.services/observatory.indra.service';
import { CreditCard, CardBrand, DataUserPayment } from '@ibe.models/payment_method.model';
import { INDRASavedCardDeleteRequest } from '@ibe.models/payment_creditcard.model';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRA_cvcCustomValidator, validateCardNumber, validateCVCNumber } from './credit-card-validator';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRARadioInputGroupComponent } from '@ibe.components/common/inputs/radio-input-group/radio-input-group.indra.component';
import { INDRATAPUserAddress } from '@ibe.models/user.indra.model.lib';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRACurrencyService } from '@ibe.services/currency.indra.service';
import { INDRABookingPaymentService } from '@ibe.services/booking-payment.indra.service';
import { SidebarService } from '@ibe/services/ui';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DEFAULT_LANGUAGE, INDRA_US_STATES_URL, INDRA_CA_STATES_URL, INDRA_BR_STATES_URL, INDRA_AU_STATES_URL, INDRA_AR_STATES_URL, SESSION_VAR_KEY_MARKET, COUNTRY_CODE_BRAZIL, PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE, PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE_AWARD, PAYMENT_METHOD_PARAM_PTD, PAYMENT_METHOD_PARAM_INSTALLMENT, PAYMENT_ADDRESS_FIELDS_REQUIRED_MARKET, PAYMENT_METHOD_CREDIT_CARDS, SESSION_VAR_KEY_LANGUAGE, SPECIAL_CASE_MARKET_LANGUAGE_MAP, DEFAULT_MARKET, COUNTRIES_TRANSLATION_KEY } from '@ibe.config';
// imports from phase 2
import { ModalService, ScreenService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { fromEvent, combineLatest } from 'rxjs';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';
import { INDRADateService } from '@ibe.services/date.indra.service';
import { ParamsIndraService } from '@ibe.services/params.service';
var INDRAPaymentMethodCardComponent = /** @class */ (function () {
    function INDRAPaymentMethodCardComponent(router, fb, _http, paymentService, payment, observatory, storage, bfmStorage, ibeAdminService, store, modalService, screen, currencyService, sidebarService, bookingPaymentService, ibeAdminConfigService, dateService, paramsService) {
        var _this = this;
        this.router = router;
        this.fb = fb;
        this._http = _http;
        this.paymentService = paymentService;
        this.payment = payment;
        this.observatory = observatory;
        this.storage = storage;
        this.bfmStorage = bfmStorage;
        this.ibeAdminService = ibeAdminService;
        this.store = store;
        this.modalService = modalService;
        this.screen = screen;
        this.currencyService = currencyService;
        this.sidebarService = sidebarService;
        this.bookingPaymentService = bookingPaymentService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.dateService = dateService;
        this.paramsService = paramsService;
        this.isAlive = true;
        this.type = 'credit';
        this.displayCovidTermsAndCondition = false;
        this.acceptedTermsAndConditions = false;
        this.activeCardType = undefined;
        // hasErrors = false;
        this.isValid = false;
        this.creditCardList = [];
        this.cardWithoutCvc = false;
        this.countriesWithStateValues = ['BR', 'CA', 'US', 'AU', 'AR'];
        this.showStateField = false;
        this.availableCards = [];
        this.countryCodes = Array();
        this.stateCodes = [];
        this.stateCodesUS = [];
        this.stateCodesCA = [];
        this.stateCodesBR = [];
        this.stateCodesAU = [];
        this.stateCodesAR = [];
        this.stateOptions = Array();
        this.payWithInstalments = false;
        this.cardholderWillTravel = undefined;
        // cardholderWillTravelObs;
        this.hiddenForm = false;
        this.alertMethodsPayment = false;
        this.cardBrands = new Map([
            ['visa', new CardBrand('VI', 'visa', 'credit_card--visa', 'Visa', '^4[0-9]{0,3}$', 'TAPIBE_pt')],
            ['mastercard', new CardBrand('MC', 'mastercard', 'credit_card--mastercard', 'Mastercard', '^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$', 'TAPIBE_pt')],
            ['maestro', new CardBrand('MA', 'maestro', 'credit_card--maestro', 'Maestro', '^(5[06789]|6)[0-9]{0,}$', 'TAPIBE_pt')],
            // ['american_express', new CardBrand('AX', 'american_express', 'american_express', 'American Express', '^3[47][0-9]{0,}$', 'TAPIBE_pt')], 
            ['amex', new CardBrand('AX', 'amex', 'credit_card--american_express', 'American Express', '^3[47][0-9]{0,}$', 'TAPIBE_pt')],
            ['uatp', new CardBrand('UA', 'uatp', 'credit_card--uatp', 'Universal Air Travel Plan', '^1[0-9]{0,}$', 'TAPIBE_pt')],
            ['elo', new CardBrand('EL', 'elo', 'credit_card--elo', 'Elo', '^(?:401178|401179|431274|438935|451416|457393|457631|457632|504175|627780|636297|636368|655000|655001|651652|651653|651654|650485|650486|650487|650488|506699|5067[0-6][0-9]|50677[0-8]|509\\d{3})\\d{10}$', 'TAPIBE_pt')],
            ['diners_club', new CardBrand('DC', 'diners_club', 'credit_card--diners_club', 'Diners Club', '^3(?:0[0-59]{1}|[689])[0-9]{0,}$', 'TAPIBE_pt')],
            ['discover', new CardBrand('', 'discover', 'credit_card--discover', 'Discover', '^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$', 'TAPIBE_pt')],
            ['airplus', new CardBrand('', 'airplus', 'credit_card--airplus', 'AirPlus International', '', 'TAPIBE_pt')],
            ['hipercard', new CardBrand('HC', 'hipercard', 'credit_card--hipercard', 'Hipercard', '^(606282\\d{10}(\\d{3})?)|(3841\\d{15})$', 'TAPIBE_pt')],
            ['carte_bleue', new CardBrand('CB', 'carte_bleue', '', 'Cartes Bleue', '^[0-9]*$', 'TAPIBE_pt')],
            ['bancontact', new CardBrand('BC', 'bancontact', 'payment_method--bancontact', 'Bancontact', '', 'TAPIBE_pt')],
        ]);
        this.regexMC = '^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[01]|2720)[0-9]{0,}$';
        this.regexVI = '^4[0-9]{0,}$';
        this.regexAX = '^3[47][0-9]{0,}$';
        this.regexMA = '^(5[06789]|6)[0-9]{0,}$';
        this.regexEL = '^(?:401178|401179|431274|438935|451416|457393|457631|457632|504175|627780|636297|636368|655000|655001|651652|651653|651654|650485|650486|650487|650488|506699|5067[0-6][0-9]|50677[0-8]|509\d{3})\d{10}$';
        this.regexHC = '/^(606282\d{10}(\d{3})?)|(3841\d{15})$/';
        this.regexDN = '^3(?:0[0-59]{1}|[689])[0-9]{0,}$';
        this.regexTP = '^1[0-9]{0,}$';
        this.regexDS = '^(6011|65|64[4-9]|62212[6-9]|6221[3-9]|622[2-8]|6229[01]|62292[0-5])[0-9]{0,}$';
        this.regexBC = ''; // TODO provide bancontact REGEX
        this.allSubscriptions = [];
        this.userInfo$ = this.store.select(fromStore.getUserInfo);
        this.userInfo = null;
        this.bookAwardFlights$ = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        this.okToDelete$ = this.store.select(fromStore.getConfirmModalConfirm);
        this.okToDelete = '';
        this.isMobile$ = this.store.select(fromStore.isScreenMobile);
        this.isMobile = false;
        this.isIE = false || !!document['documentMode'];
        // isOpen = false;
        // invalidDate = '';
        this.extras$ = this.store.select(fromStore.getSelectedBookedTripExtras);
        this.extras = [];
        this.hasHotelRoom = false;
        this.availableCardBrandOptions = [];
        this.cardsType = [
            'visa',
            'mastercard',
            'maestro',
            // 'american_express',
            'amex',
            'uatp',
            'elo',
            'diners_club',
            'discover',
            'airplus',
            'hipercard'
            // 'carte_bleue',
            // 'cartes_bancaries',
        ];
        this.cardsTypeDebit = [
            'visa',
            'mastercard',
            'maestro',
            'bancontact'
        ];
        this.installmentOptions = Array();
        this.installmentCount = 0;
        this.hasInstallmentConfig = false;
        this.intervalMonth = [
            { text: '01', value: 1 },
            { text: '02', value: 2 },
            { text: '03', value: 3 },
            { text: '04', value: 4 },
            { text: '05', value: 5 },
            { text: '06', value: 6 },
            { text: '07', value: 7 },
            { text: '08', value: 8 },
            { text: '09', value: 9 },
            { text: '10', value: 10 },
            { text: '11', value: 11 },
            { text: '12', value: 12 },
        ];
        this.intervalYear = [];
        this.cardHolderTravelOptions = [
            { label: 'shoppingBasket.text.yes', selected: false, id: 'cardholder_will_travel-yes' },
            { label: 'shoppingBasket.text.no', selected: false, id: 'cardholder_will_travel-no' }
        ];
        this.payWithInstallmentOptions = [
            { label: 'shoppingBasket.text.yes', selected: false, id: 'pay_with_instalments-yes' },
            { label: 'shoppingBasket.text.no', selected: false, id: 'pay_with_instalments-no' }
        ];
        this.acceptedConditionOther = false;
        this.acceptedConditionAvailable = false;
        this.acceptedConditionExpired = false;
        this.acceptedHotelConditionOther = false;
        this.acceptedHotelConditionAvailable = false;
        this.acceptedHotelConditionExpired = false;
        this.isBrazilMarket = false;
        this.isAddressFieldsRequired = false;
        this.logged_in = false;
        this.isTTT = false;
        this.isOCP = true;
        this.surcharge = 0;
        this.surchargeDisplay = 0;
        this.promoCodesAndVoucher$ = this.store.select(fromStore.getSelectedPromoVouchers);
        this.milesSpent$ = this.store.select(fromStore.getTotalMilesToSpend);
        this.priceChanges$ = combineLatest(this.promoCodesAndVoucher$, this.milesSpent$);
        this.currency = this.currencyService.INDRA_getCurrencySymbol().name;
        this.market = this.storage.get(SESSION_VAR_KEY_MARKET);
        this.isTTT = this.router.url.includes('/time-to-think/payment') ? true : false;
        // display installment fields if Brazil Market
        this.isBrazilMarket = (this.market && this.market === COUNTRY_CODE_BRAZIL) ? true : false;
        this.bookAwardFlights$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.bookAwardFlights = value;
        });
        if (this.availableCards.length === 0) {
            this.selectedCard = undefined;
            this.selectedCardType = undefined;
        }
        // Initialize countryCodes variable
        this.getCountryCodes();
        // Create form
        this.INDRA_createFormClasses();
        this.userInfo$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (values) {
            _this.userInfo = values;
            _this.logged_in = _this.userInfo ? true : false;
            _this.INDRA_getPaymentMethodTest();
        });
        this.isMobile$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) { _this.isMobile = value; });
        this.resize$ = fromEvent(window, 'resize')
            .pipe(debounceTime(250), map(function () { return window.innerWidth; }), distinctUntilChanged(), startWith(window.innerWidth), tap(function (width) { return _this.screen.setWindowWidth(Number(width)); }));
        this.okToDelete$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.okToDelete = value;
            }
        });
        this.setYearListDefault();
        this.paymentService.clearPaymentForm
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (clearForm) {
            if (clearForm) {
                // reset form
                _this.INDRA_resetForm();
                _this.INDRA_setAvailableCardsOptions();
                _this.INDRA_setupUserBasedFormbehavior();
                _this.paymentService.setClearPaymentForm(false);
            }
        });
        this.priceChanges$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (_a) {
            var promoCodesAndVoucher = _a[0], milesSpent = _a[1];
            if (_this.isBrazilMarket) {
                _this.INDRA_resetPayWithInstallments(false);
            }
        });
        /*
        this.paymentService.surchargeAmount
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(surchargeAmount => {
                if (this.isBrazilMarket) {
                    this.INDRA_resetPayWithInstallments(false);
                }
            });
        */
        this.paymentService.installmentAmount
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (installmentAmount) {
            _this.bookingCashTotalAmount = installmentAmount;
            if (_this.isBrazilMarket) {
                _this.INDRA_updateInstallmentOptions(installmentAmount);
            }
        });
    }
    INDRAPaymentMethodCardComponent.prototype.isFOPTypeBancontact = function () {
        return this.type === 'bancontact';
    };
    INDRAPaymentMethodCardComponent.prototype.setYearListDefault = function () {
        var yearList = [];
        var currentYear = moment().year() - 2000;
        for (var i = currentYear; i <= currentYear + 20; i++) {
            yearList.push({ text: i, value: i });
        }
        this.intervalYear = yearList;
    };
    INDRAPaymentMethodCardComponent.prototype.trackByFn = function (index, item) {
        return index; // or item.id
    };
    INDRAPaymentMethodCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        // show or hide address fields depending on the market
        this.isAddressFieldsRequired = (this.market && PAYMENT_ADDRESS_FIELDS_REQUIRED_MARKET.includes(this.market)) && !this.isFOPTypeBancontact() ? true : false;
        // set active card type to bancontact if the card type is bancontact (since there is no card selection for the bancontact FOP
        if (this.isFOPTypeBancontact()) {
            this.activeCardType = 'bancontact';
        }
        this.INDRA_setAvailableCardsOptions();
        this.INDRA_createFormClasses();
        this.ibeAdminService.loadTranslations("tap", ["shoppingBasket"], (sessionStorage.getItem('language') ? sessionStorage.getItem('language') : DEFAULT_LANGUAGE));
        this.extras$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.extras = value;
                var hotels = _this.extras.find(function (extra) { return extra.type === 'hotel'; });
                _this.hasHotelRoom = (hotels && hotels.data && hotels.data.length > 0) ? true : false;
            }
            else {
                _this.hasHotelRoom = false;
            }
            // update form validation
            _this.INDRA_updateCardForm();
        });
        this.formChangesSubscription = this.formOtherCard.statusChanges.subscribe(function (value) {
            if (_this.selectedCardType === 'other') {
                var isPaymentFormValid = _this.paymentService.getFormIsValid();
                if (_this.cardholderWillTravel === undefined || _this.activeCardType === undefined) {
                    if (isPaymentFormValid) {
                        _this.paymentService.setFormIsValid(false);
                    }
                    _this.INDRA_checkRequiredFields(_this.formOtherCard);
                }
                else {
                    if (value === 'VALID') {
                        if (!isPaymentFormValid) {
                            _this.paymentService.setFormIsValid(true);
                            _this.INDRA_setPaymentInfoOnService();
                        }
                    }
                    else {
                        if (isPaymentFormValid) {
                            _this.paymentService.setFormIsValid(false);
                        }
                        _this.INDRA_checkRequiredFields(_this.formOtherCard);
                    }
                }
            }
        });
        this.formAvailableSubscription = this.formAvailableCard
            .statusChanges.subscribe(function (value) {
            if (_this.selectedCardType === 'available') {
                var isPaymentFormValid = _this.paymentService.getFormIsValid();
                if (value === 'VALID') {
                    if (!isPaymentFormValid) {
                        _this.paymentService.setFormIsValid(true);
                        _this.INDRA_setPaymentInfoOnService();
                    }
                }
                else {
                    if (isPaymentFormValid) {
                        _this.paymentService.setFormIsValid(false);
                        _this.INDRA_setPaymentInfoOnService(false);
                    }
                    _this.INDRA_checkRequiredFields(_this.formAvailableCard);
                }
            }
        });
        this.formExpiredSubscription = this.formExpiredCard.statusChanges.subscribe(function (value) {
            if (_this.selectedCardType === 'expired') {
                var isPaymentFormValid = _this.paymentService.getFormIsValid();
                if (value === 'VALID') {
                    if (!isPaymentFormValid) {
                        _this.paymentService.setFormIsValid(true);
                        _this.INDRA_setPaymentInfoOnService();
                    }
                }
                else {
                    if (isPaymentFormValid) {
                        _this.paymentService.setFormIsValid(false);
                    }
                }
            }
        });
        this.resize$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe();
        // get the applicable surcharge percentage from the credit card payment methods
        if ((this.type === 'credit') && this.bookAwardFlights === false && this.isTTT === false) {
            this.INDRA_getApplicableSurchargeDisplay();
        }
        this.INDRA_setupUserBasedFormbehavior();
        this.allSubscriptions.push(this.submitSubscription);
        this.allSubscriptions.push(this.formChangesSubscription);
        this.allSubscriptions.push(this.formExpiredSubscription);
        this.allSubscriptions.push(this.formAvailableSubscription);
        // this.TAP_DateErrors();
    };
    INDRAPaymentMethodCardComponent.prototype.ngOnDestroy = function () {
        // set to 0 to reset surcharge since this component will be destroyed when switching to another FOP 
        // (and surcharge might not be applicable to the other FOP components)
        this.paymentService.setSurcharge(0);
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub)
                sub.unsubscribe();
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_getApplicableSurcharge = function () {
        var paymentMethod = this.bfmStorage.INDRA_getPaymentMethod();
        this.isOCP = paymentMethod.data.cardOcpEnable;
        if (paymentMethod && paymentMethod.data && paymentMethod.data.fops && paymentMethod.data.fops.length > 0) {
            var fopsWithSurcharge = paymentMethod.data.fops.filter(function (fop) { return PAYMENT_METHOD_CREDIT_CARDS.includes(fop.fopCode) && fop.fee && fop.fee.amount > 0; });
            if (fopsWithSurcharge.length > 0) {
                this.surcharge = fopsWithSurcharge[0].fee.amount;
                this.paymentService.setSurcharge(this.surcharge);
            }
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_setupUserBasedFormbehavior = function () {
        // set logged-in user info on the form
        this.dataUser = this.storage.get('userData');
        if (this.dataUser) {
            if (this.dataUser.lastName && this.dataUser.firstName) {
                this.formOtherCard.controls['first_name'].setValue(this.dataUser.firstName);
                this.formOtherCard.controls['last_name'].setValue(this.dataUser.lastName);
            }
            if (this.isAddressFieldsRequired && this.dataUser.userAddress) {
                this.userAddress = this.dataUser.userAddress;
                if (this.userAddress.address)
                    this.formOtherCard.controls['adress'].setValue(this.userAddress.address);
                if (this.userAddress.city)
                    this.formOtherCard.controls['city'].setValue(this.userAddress.city);
                if (this.userAddress.zipCode)
                    this.formOtherCard.controls['zip_code'].setValue(this.userAddress.zipCode);
                if (this.userAddress.country) {
                    this.formOtherCard.controls['country'].setValue(this.userAddress.country);
                    // call form changes to setup the state dropdown list if applicable
                    this.INDRA_formChanges(this.userAddress.country);
                }
            }
        }
        else {
            // if user is not logged in, by default the type of card selected would be others
            this.INDRA_selectCard();
        }
    };
    // TODO improve this and implement retrieval of debit card list from payment method API FOPs
    INDRAPaymentMethodCardComponent.prototype.INDRA_getPaymentMethodTest = function () {
        var _this = this;
        var paymentMethod = this.bfmStorage.INDRA_getPaymentMethod();
        this.isOCP = paymentMethod.data.cardOcpEnable;
        if (paymentMethod && paymentMethod.data) {
            if (paymentMethod.data.fops && paymentMethod.data.fops.length > 0) {
                var merchantAccountParamName_1 = this.bookAwardFlights ? PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE_AWARD : PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE;
                var cardBrandsService = paymentMethod.data.fops;
                cardBrandsService.forEach(function (element) {
                    // merchant account
                    var merchantAccountEl = element.params.filter(function (el) { return el.paramCode === merchantAccountParamName_1; });
                    var merchantAccount = merchantAccountEl && merchantAccountEl.length > 0 ? merchantAccountEl[0].paramValue : null;
                    // not used yet
                    var ptdEl = element.params.filter(function (el) { return el.paramCode === PAYMENT_METHOD_PARAM_PTD; });
                    var ptd = ptdEl && ptdEl.length > 0 ? ptdEl[0].paramValue : null;
                    // installemment
                    var installment = element.params.filter(function (el) { return el.paramCode === PAYMENT_METHOD_PARAM_INSTALLMENT; });
                    var installmentCount = installment && installment.length > 0 && installment[0].paramValue ? +installment[0].paramValue : 0;
                    if (installmentCount && installmentCount != 0) {
                        _this.hasInstallmentConfig = true;
                        _this.installmentCount = installmentCount;
                    }
                    switch (element.fopCode) {
                        case 'MC':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'mastercard', 'credit_card--mastercard', element.fopName, _this.regexMC, merchantAccount, 'mc', element.fee));
                            break;
                        case 'VI':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'visa', 'credit_card--visa', element.fopName, _this.regexVI, merchantAccount, 'visa', element.fee));
                            break;
                        case 'AX':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'amex', 'credit_card--american_express', element.fopName, _this.regexAX, merchantAccount, 'amex', element.fee));
                            break;
                        case 'MA':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'maestro', 'credit_card--maestro', element.fopName, _this.regexMA, merchantAccount, 'maestro', element.fee));
                            break;
                        case 'EL':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'elo', 'credit_card--elo', element.fopName, _this.regexEL, merchantAccount, 'elo', element.fee));
                            break;
                        case 'HC':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'hipercard', 'credit_card--hipercard', element.fopName, _this.regexHC, merchantAccount, 'hiper', element.fee));
                            break;
                        case 'DC':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'diners_club', 'credit_card--diners_club', element.fopName, _this.regexDN, merchantAccount, 'diners', element.fee));
                            break;
                        case 'TP':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'uatp', 'credit_card--uatp', element.fopName, _this.regexTP, merchantAccount, 'uatp', element.fee));
                            break;
                        case 'DS':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'discover', 'credit_card--discover', element.fopName, _this.regexDS, merchantAccount, 'discover', element.fee));
                            break;
                        case 'BC':
                            _this.creditCardList.push(new CreditCard(element.fopCode, 'bancontact', 'payment_method--bancontact', element.fopName, _this.regexTP, merchantAccount, 'bancontact', element.fee));
                            break;
                        /*
                        case 'CB':
                            this.creditCardList.push(new CreditCard(element.fopCode, 'cartes_bancaries', 'cartes_bancaries', element.fopName, this.regexCB, merchantAccount, 'cb'));
                            break;
                        */
                        // case 'MD':
                        // 	this.creditCardList.push(new CreditCard(element.fopCode, 'maestro', 'maestro', element.fopName, this.regexMA, 'TAPIBE_pt'));
                        // 	break;
                        // case 'VD':
                        // 	this.creditCardList.push(new CreditCard(element.fopCode, 'visa', 'visa', element.fopName, this.regexVI, 'TAPIBE_pt'));
                        // 	break;
                        default:
                            break;
                    }
                });
                this.putCustomValidator();
                this.INDRA_getStoredCardDetails(paymentMethod.data, merchantAccountParamName_1);
            }
            else {
                this.hiddenForm = true;
                this.alertMethodsPayment = true;
                // this.hiddenButton = true;
            }
        }
        else {
            this.hiddenForm = true;
            this.alertMethodsPayment = true;
            // this.hiddenButton = true;
        }
    };
    /**
     * Create form group
     */
    INDRAPaymentMethodCardComponent.prototype.INDRA_createFormClasses = function () {
        // Create form group with controls and validators
        // Available Card form
        this.formAvailableCard = this.fb.group({
            pay_with_instalments: [null],
            instalments_option: [null],
            instalments_cpf: [null],
            security_code: [null, [Validators.required, Validators.maxLength(4), Validators.pattern('[0-9]+')]],
            accepted_send_user_info: [null],
            accepted_conditions: [null, [Validators.requiredTrue]]
        });
        // Expired Card form
        this.formExpiredCard = this.fb.group({
            card_number: [
                null,
                [
                    Validators.required,
                    Validators.minLength(14),
                    Validators.maxLength(19),
                    Validators.pattern('[0-9]+')
                ]
            ],
            security_code: [
                null,
                [
                    Validators.required,
                    Validators.maxLength(4),
                    Validators.pattern('[0-9]+')
                ]
            ],
            expiration_date_month: [null, [Validators.required]],
            expiration_date_year: [null, [Validators.required]],
            accepted_send_user_info: [null],
            accepted_conditions: [null, [Validators.requiredTrue]]
        });
        // Other Card form
        if (this.isAddressFieldsRequired) {
            this.formOtherCard = this.fb.group({
                pay_with_instalments: [null],
                instalments_option: [null],
                instalments_cpf: [null],
                cardholder_will_travel: [null, [Validators.required]],
                card_brand: [null, [Validators.required]],
                // name_on_card: [null, [Validators.required]],
                first_name: [null, [Validators.required, Validators.pattern('[a-zA-Z_ ]+')]],
                last_name: [null, [Validators.required, Validators.pattern('[a-zA-Z_ ]+')]],
                card_number: [null, [Validators.required, Validators.minLength(14), Validators.maxLength(19)]],
                security_code: [null, [Validators.minLength(3), Validators.maxLength(4), Validators.pattern('[0-9]+')]],
                expiration_date_month: [null, [Validators.required]],
                expiration_date_year: [null, [Validators.required]],
                adress: [null, [Validators.required, Validators.maxLength(60)]],
                zip_code: [null, [Validators.required]],
                city: [null, [Validators.required]],
                country: [null, [Validators.required]],
                state: [null],
                save_card: [null],
                accepted_send_user_info: [null],
                accepted_conditions: [null, [Validators.requiredTrue]]
            }, {
                validator: INDRA_cvcCustomValidator('card_number', 'security_code')
            });
        }
        else {
            if (this.isFOPTypeBancontact()) {
                this.formOtherCard = this.fb.group({
                    pay_with_instalments: [null],
                    instalments_option: [null],
                    instalments_cpf: [null],
                    cardholder_will_travel: [null, [Validators.required]],
                    card_brand: [null],
                    // name_on_card: [null, [Validators.required]],
                    first_name: [null, [Validators.required, Validators.pattern('[a-zA-Z_ ]+')]],
                    last_name: [null, [Validators.required, Validators.pattern('[a-zA-Z_ ]+')]],
                    card_number: [null, [Validators.required, Validators.minLength(14), Validators.maxLength(19)]],
                    security_code: [null],
                    expiration_date_month: [null, [Validators.required]],
                    expiration_date_year: [null, [Validators.required]],
                    adress: [null],
                    zip_code: [null],
                    city: [null],
                    country: [null],
                    state: [null],
                    save_card: [null],
                    accepted_send_user_info: [null],
                    accepted_conditions: [null, [Validators.requiredTrue]]
                });
            }
            else {
                this.formOtherCard = this.fb.group({
                    pay_with_instalments: [null],
                    instalments_option: [null],
                    instalments_cpf: [null],
                    cardholder_will_travel: [null, [Validators.required]],
                    card_brand: [null, [Validators.required]],
                    // name_on_card: [null, [Validators.required]],
                    first_name: [null, [Validators.required, Validators.pattern('[a-zA-Z_ ]+')]],
                    last_name: [null, [Validators.required, Validators.pattern('[a-zA-Z_ ]+')]],
                    card_number: [null, [Validators.required, Validators.minLength(14), Validators.maxLength(19)]],
                    security_code: [null, [Validators.minLength(3), Validators.maxLength(4), Validators.pattern('[0-9]+')]],
                    expiration_date_month: [null, [Validators.required]],
                    expiration_date_year: [null, [Validators.required]],
                    adress: [null],
                    zip_code: [null],
                    city: [null],
                    country: [null],
                    state: [null],
                    save_card: [null],
                    accepted_send_user_info: [null],
                    accepted_conditions: [null, [Validators.requiredTrue]]
                }, {
                    validator: INDRA_cvcCustomValidator('card_number', 'security_code')
                });
            }
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_resetForm = function () {
        this.activeCardType = this.isFOPTypeBancontact() ? 'bancontact' : undefined;
        this.cardHolderTravelOptions.forEach(function (option) { return option.selected = false; });
        if (!_.isNil(this.formAvailableCard)) {
            this.resetFormFields(this.formAvailableCard);
            this.acceptedConditionAvailable = false;
            this.acceptedHotelConditionAvailable = false;
        }
        if (!_.isNil(this.formExpiredCard)) {
            this.resetFormFields(this.formExpiredCard);
            this.acceptedConditionExpired = false;
            this.acceptedHotelConditionExpired = false;
        }
        if (!_.isNil(this.formOtherCard)) {
            this.resetFormFields(this.formOtherCard);
            this.acceptedConditionOther = false;
            this.acceptedHotelConditionOther = false;
        }
        if (!this.isFOPTypeBancontact())
            this.INDRA_checkIfCVCApplicable();
        this.updateMonthList();
        this.updateYearList();
    };
    INDRAPaymentMethodCardComponent.prototype.resetFormFields = function (fg) {
        Object.keys(fg.controls).forEach(function (key) {
            var formControl = fg.get(key);
            if (formControl instanceof AbstractControl) {
                formControl.reset();
                formControl.updateValueAndValidity();
            }
        });
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_updateCardForm = function () {
        if (this.hasHotelRoom && this.type === 'credit') {
            this.formAvailableCard.controls['accepted_send_user_info'].setValidators(Validators.requiredTrue);
            this.formAvailableCard.controls['accepted_send_user_info'].updateValueAndValidity();
            this.formExpiredCard.controls['accepted_send_user_info'].setValidators(Validators.requiredTrue);
            this.formExpiredCard.controls['accepted_send_user_info'].updateValueAndValidity();
            this.formOtherCard.controls['accepted_send_user_info'].setValidators(Validators.requiredTrue);
            this.formOtherCard.controls['accepted_send_user_info'].updateValueAndValidity();
        }
        else {
            this.formAvailableCard.controls['accepted_send_user_info'].clearValidators();
            this.formAvailableCard.controls['accepted_send_user_info'].updateValueAndValidity();
            this.formExpiredCard.controls['accepted_send_user_info'].clearValidators();
            this.formExpiredCard.controls['accepted_send_user_info'].updateValueAndValidity();
            this.formOtherCard.controls['accepted_send_user_info'].clearValidators();
            this.formOtherCard.controls['accepted_send_user_info'].updateValueAndValidity();
        }
    };
    INDRAPaymentMethodCardComponent.prototype.putCustomValidator = function (cardbrand) {
        if (this.selectedCardType === 'other') {
            this.formOtherCard.controls['card_number'].setValidators(Validators.compose([
                Validators.required,
                // INDRA_creditCardValidator(Array.from(this.cardBrands, ([key, value]) => value.code).filter((x: string) => x !== undefined && x.trim().length > 0)),
                // INDRA_creditCardValidator(this.creditCardList.map((y) => y.code).filter((x: string) => x !== undefined && x.trim().length > 0), cardbrand),
                validateCardNumber(),
                Validators.maxLength(20)
            ]));
            this.formOtherCard.controls['card_number'].updateValueAndValidity();
            //CUSTOM VALIDATORS: CVC ('security_code')
            this.formOtherCard.controls['security_code'].setValidators(Validators.compose([
                Validators.minLength(3),
                Validators.pattern('[0-9]+'),
                validateCVCNumber(this.activeCardType)
            ]));
            this.formOtherCard.controls['security_code'].updateValueAndValidity();
        }
        else if (this.selectedCardType === 'expired') {
            this.formExpiredCard.controls['card_number'].setValidators(Validators.compose([
                Validators.required,
                // INDRA_creditCardValidator(Array.from(this.cardBrands, ([key, value]) => value.code).filter((x: string) => x !== undefined && x.trim().length > 0)),
                // INDRA_creditCardValidator(this.creditCardList.map((y) => y.code).filter((x: string) => x !== undefined && x.trim().length > 0), cardbrand),
                validateCardNumber(),
                Validators.maxLength(20)
            ]));
            this.formExpiredCard.controls['card_number'].updateValueAndValidity();
            //CUSTOM VALIDATORS: CVC ('security_code')
            this.formOtherCard.controls['security_code'].setValidators(Validators.compose([
                Validators.minLength(3),
                Validators.pattern('[0-9]+'),
                validateCVCNumber(this.activeCardType)
            ]));
            this.formOtherCard.controls['security_code'].updateValueAndValidity();
        }
    };
    /**
     * Returns class to a formControl if it's not valid
     * @param {FormControl} formControl to check if has any error
     * @returns {Object} with matched classes
     */
    INDRAPaymentMethodCardComponent.prototype.INDRA_hasErrors = function (control) {
        return !control.valid && control.touched;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_hasErrorsClasses = function (control) {
        return {
            'has-error': this.INDRA_hasErrors(control)
        };
    };
    /**
     * Returns has-error class to a formControl if it's not valid
     * @param {FormControl} formControl to check if has any error
     */
    INDRAPaymentMethodCardComponent.prototype.INDRA_hasErrorsReturnClass = function (control) {
        if (this.INDRA_hasErrors(control)) {
            return 'has-error';
        }
    };
    /**
     * Check if a control is invalid to show error messages
     */
    INDRAPaymentMethodCardComponent.prototype.INDRA_formErrors = function (control, control_name) {
        var errors = [];
        if (control_name === 'card_number') {
            if (control.hasError('maxLength') || control.hasError('creditCardInvalid')) {
                errors[0] = 'shoppingBasket.text.InvalidCardNumber';
            }
            if (control.hasError('required')) {
                errors[0] = 'shoppingBasket.text.requiredCardNumber';
            }
            if (control.hasError('minlength')) {
                errors[0] = 'shoppingBasket.text.minimumCardNumber';
            }
        }
        else if (control_name === 'instalments_option') {
            if (control.hasError('required')) {
                errors[0] = 'shoppingBasket.text.requiredInstallmentOption';
            }
        }
        else if (control_name === 'instalments_cpf') {
            if (control.hasError('required')) {
                errors[0] = 'shoppingBasket.text.requiredCPF';
            }
        }
        else if (control_name === 'cardholder_will_travel') {
            if (control.hasError('required')) {
                errors[0] = 'shoppingBasket.text.requiredCardholderWillTravel';
            }
        }
        else if (control_name === 'security_code') {
            if (control.hasError('badValueFound')) {
                errors[0] = 'shoppingBasket.text.requiredSecurityCode';
            }
            if (control.hasError('maxLength') || control.hasError('minlength') || control.hasError('pattern')) {
                errors[0] = 'shoppingBasket.text.notValidSecurityCode';
            }
        }
        else if (control_name === 'card_brand') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredCCType');
            }
        }
        else if (control_name === 'expiration_date_month') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredExpirationDateMonth');
            }
        }
        else if (control_name === 'expiration_date_year') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredExpirationDateYear');
            }
        }
        else if (control_name === 'first_name') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredFirstName');
            }
            if (control.hasError('pattern')) {
                errors.push('shoppingBasket.text.firstNameInvalid');
            }
        }
        else if (control_name === 'last_name') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredLastName');
            }
            if (control.hasError('pattern')) {
                errors.push('shoppingBasket.text.lastNameInvalid');
            }
        }
        /* TODO implement this
        else if (control_name === 'name_on_card') {
            if (control.hasError('required')) {
                errors.push('You have to select a card type');
            }
        }
        */
        else if (control_name === 'date_of_birth_day') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredDateOfBirthDay');
            }
        }
        else if (control_name === 'date_of_birth_month') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredDateOfBirthMonth');
            }
        }
        else if (control_name === 'date_of_birth_year') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredDateOfBirthYear');
            }
        }
        else if (control_name === 'adress') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredAddress');
            }
        }
        else if (control_name === 'zip_code') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredZipCode');
            }
        }
        else if (control_name === 'city') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredCity');
            }
        }
        else if (control_name === 'country') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredCountry');
            }
        }
        else if (control_name === 'accepted_conditions') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredYouNeedToAccept');
            }
        }
        else if (control_name === 'accepted_send_user_info') {
            if (control.hasError('required')) {
                errors.push('You need to accept these conditions before continue');
            }
        }
        else if (control_name === 'state') {
            if (control.hasError('required')) {
                errors.push('shoppingBasket.text.requiredState');
            }
        }
        return errors.join('; ');
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_isActiveCardType = function (cardType) {
        return { 'is-active': this.activeCardType === cardType };
    };
    /**
     * Get list of countries with phone codes from file
     */
    INDRAPaymentMethodCardComponent.prototype.getCountryCodes = function () {
        var _this = this;
        var URL = './assets/data/country_codes.json';
        var filePromise = this._http.get(URL).toPromise();
        filePromise.then(function (data) {
            data.forEach(function (cc) {
                _this.countryCodes.push({
                    text: _this.INDRA_getTranslation(COUNTRIES_TRANSLATION_KEY + cc.code.toLowerCase()),
                    value: cc.code
                });
            });
            _this.countryCodes.sort(function (a, b) { return a.text.localeCompare(b.text); });
        }, function (err) {
            console.error(err);
        });
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_getStateCodes = function (countryCode) {
        return __awaiter(this, void 0, void 0, function () {
            var stateCodePromise, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = countryCode;
                        switch (_a) {
                            case 'US': return [3 /*break*/, 1];
                            case 'CA': return [3 /*break*/, 3];
                            case 'BR': return [3 /*break*/, 5];
                            case 'AU': return [3 /*break*/, 7];
                            case 'AR': return [3 /*break*/, 9];
                        }
                        return [3 /*break*/, 11];
                    case 1: return [4 /*yield*/, this._http.get(INDRA_US_STATES_URL).toPromise()];
                    case 2:
                        stateCodePromise = _b.sent();
                        return [3 /*break*/, 12];
                    case 3: return [4 /*yield*/, this._http.get(INDRA_CA_STATES_URL).toPromise()];
                    case 4:
                        stateCodePromise = _b.sent();
                        return [3 /*break*/, 12];
                    case 5: return [4 /*yield*/, this._http.get(INDRA_BR_STATES_URL).toPromise()];
                    case 6:
                        stateCodePromise = _b.sent();
                        return [3 /*break*/, 12];
                    case 7: return [4 /*yield*/, this._http.get(INDRA_AU_STATES_URL).toPromise()];
                    case 8:
                        stateCodePromise = _b.sent();
                        return [3 /*break*/, 12];
                    case 9: return [4 /*yield*/, this._http.get(INDRA_AR_STATES_URL).toPromise()];
                    case 10:
                        stateCodePromise = _b.sent();
                        return [3 /*break*/, 12];
                    case 11: return [3 /*break*/, 12];
                    case 12: return [2 /*return*/, stateCodePromise];
                }
            });
        });
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_acceptedConditionChange = function (event, val) {
        this.acceptedTermsAndConditions = event.target.checked ? true : false;
        if (val === 'acceptedConditionOther') {
            this.acceptedConditionOther = !this.acceptedConditionOther;
        }
        if (val === 'acceptedConditionAvailable') {
            this.acceptedConditionAvailable = !this.acceptedConditionAvailable;
        }
        if (val === 'acceptedConditionExpired') {
            this.acceptedConditionExpired = !this.acceptedConditionExpired;
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_acceptedHotelConditionChange = function (val) {
        if (val === 'acceptedHotelConditionOther') {
            this.acceptedHotelConditionOther = !this.acceptedHotelConditionOther;
        }
        if (val === 'acceptedHotelConditionAvailable') {
            this.acceptedHotelConditionAvailable = !this.acceptedHotelConditionAvailable;
        }
        if (val === 'acceptedHotelConditionExpired') {
            this.acceptedHotelConditionExpired = !this.acceptedHotelConditionExpired;
        }
    };
    INDRAPaymentMethodCardComponent.prototype.updateMonthList = function (selectedYear) {
        var newMonthList = [];
        if (selectedYear) {
            for (var i = 1; i <= 12; i++) {
                var possibleDate = moment().month(i - 1).year(+selectedYear + 2000);
                if (possibleDate.isSameOrAfter(moment(), 'day')) {
                    newMonthList.push({ text: this.dateService.INDRA_addLeadingZero(i), value: i });
                }
            }
        }
        else {
            for (var i = 1; i <= 12; i++) {
                newMonthList.push({ text: this.dateService.INDRA_addLeadingZero(i), value: i });
            }
        }
        this.intervalMonth = newMonthList;
    };
    INDRAPaymentMethodCardComponent.prototype.updateYearList = function (selectedMonth) {
        if (selectedMonth) {
            // this.intervalYear = [];
            var newYearList = [];
            var currentYear = moment().year();
            for (var i = currentYear; i <= currentYear + 20; i++) {
                var possibleDate = moment().month(selectedMonth - 1).year(i);
                if (possibleDate.isSameOrAfter(moment(), 'day')) {
                    var year = i - 2000;
                    newYearList.push({ text: year, value: year });
                }
            }
            this.intervalYear = newYearList;
        }
        else {
            this.setYearListDefault();
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_formChanges = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var saveCardDataVal, cardMatch, selectedCardCode, _a, _b, _c, _d, _e, _f;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!value) return [3 /*break*/, 31];
                        if (!(value === 'save_card')) return [3 /*break*/, 1];
                        saveCardDataVal = this.formOtherCard.controls['save_card'].value;
                        if (this.saveCardData !== saveCardDataVal) {
                            this.paymentService.setSaveCardData(saveCardDataVal);
                            this.saveCardData = saveCardDataVal;
                        }
                        return [3 /*break*/, 31];
                    case 1:
                        if (!(value === 'cardChange')) return [3 /*break*/, 2];
                        if (this.formOtherCard.controls['card_brand'].value) {
                            this.activeCardType = this.formOtherCard.controls['card_brand'].value;
                            this.INDRA_checkIfCVCApplicable(this.activeCardType);
                            cardMatch = Array.from(this.creditCardList.values()).find(function (item) { return item.brand === _this.activeCardType; });
                            selectedCardCode = cardMatch ? cardMatch.code : null;
                            this.putCustomValidator(selectedCardCode);
                            // get the applicable surcharge percentage from the credit card payment methods
                            if ((this.type === 'credit') && this.bookAwardFlights === false && this.isTTT === false) {
                                this.INDRA_getApplicableSurcharge();
                            }
                        }
                        return [3 /*break*/, 31];
                    case 2:
                        if (!(value === 'otherForm_month')) return [3 /*break*/, 3];
                        this.updateYearList(this.formOtherCard.controls['expiration_date_month'].value);
                        return [3 /*break*/, 31];
                    case 3:
                        if (!(value === 'otherForm_year')) return [3 /*break*/, 4];
                        this.updateMonthList(this.formOtherCard.controls['expiration_date_year'].value);
                        return [3 /*break*/, 31];
                    case 4:
                        if (!(value === 'expiredForm_month')) return [3 /*break*/, 5];
                        this.updateYearList(this.formExpiredCard.controls['expiration_date_month'].value);
                        return [3 /*break*/, 31];
                    case 5:
                        if (!(value === 'expiredForm_year')) return [3 /*break*/, 6];
                        this.updateMonthList(this.formExpiredCard.controls['expiration_date_year'].value);
                        return [3 /*break*/, 31];
                    case 6:
                        if (!(value !== 'newState')) return [3 /*break*/, 31];
                        if (!this.isAddressFieldsRequired) return [3 /*break*/, 31];
                        if (!this.countriesWithStateValues.includes(value)) return [3 /*break*/, 29];
                        this.stateOptions = [];
                        this.showStateField = true;
                        this.formOtherCard.controls['state'].setValidators(Validators.required);
                        _a = value;
                        switch (_a) {
                            case 'US': return [3 /*break*/, 7];
                            case 'CA': return [3 /*break*/, 11];
                            case 'BR': return [3 /*break*/, 15];
                            case 'AU': return [3 /*break*/, 19];
                            case 'AR': return [3 /*break*/, 23];
                        }
                        return [3 /*break*/, 27];
                    case 7:
                        if (!(!this.stateCodesUS || this.stateCodesUS.length == 0)) return [3 /*break*/, 9];
                        _b = this;
                        return [4 /*yield*/, this.INDRA_getStateCodes(value)];
                    case 8:
                        _b.stateCodesUS = _g.sent();
                        this.stateCodes = this.stateCodesUS;
                        return [3 /*break*/, 10];
                    case 9:
                        this.stateCodes = this.stateCodesUS;
                        _g.label = 10;
                    case 10: return [3 /*break*/, 28];
                    case 11:
                        if (!(!this.stateCodesCA || this.stateCodesCA.length == 0)) return [3 /*break*/, 13];
                        _c = this;
                        return [4 /*yield*/, this.INDRA_getStateCodes(value)];
                    case 12:
                        _c.stateCodesCA = _g.sent();
                        this.stateCodes = this.stateCodesCA;
                        return [3 /*break*/, 14];
                    case 13:
                        this.stateCodes = this.stateCodesCA;
                        _g.label = 14;
                    case 14: return [3 /*break*/, 28];
                    case 15:
                        if (!(!this.stateCodesBR || this.stateCodesBR.length == 0)) return [3 /*break*/, 17];
                        _d = this;
                        return [4 /*yield*/, this.INDRA_getStateCodes(value)];
                    case 16:
                        _d.stateCodesBR = _g.sent();
                        this.stateCodes = this.stateCodesBR;
                        return [3 /*break*/, 18];
                    case 17:
                        this.stateCodes = this.stateCodesBR;
                        _g.label = 18;
                    case 18: return [3 /*break*/, 28];
                    case 19:
                        if (!(!this.stateCodesAU || this.stateCodesAU.length == 0)) return [3 /*break*/, 21];
                        _e = this;
                        return [4 /*yield*/, this.INDRA_getStateCodes(value)];
                    case 20:
                        _e.stateCodesAU = _g.sent();
                        this.stateCodes = this.stateCodesAU;
                        return [3 /*break*/, 22];
                    case 21:
                        this.stateCodes = this.stateCodesAU;
                        _g.label = 22;
                    case 22: return [3 /*break*/, 28];
                    case 23:
                        if (!(!this.stateCodesAR || this.stateCodesAR.length == 0)) return [3 /*break*/, 25];
                        _f = this;
                        return [4 /*yield*/, this.INDRA_getStateCodes(value)];
                    case 24:
                        _f.stateCodesAR = _g.sent();
                        this.stateCodes = this.stateCodesAR;
                        return [3 /*break*/, 26];
                    case 25:
                        this.stateCodes = this.stateCodesAR;
                        _g.label = 26;
                    case 26: return [3 /*break*/, 28];
                    case 27:
                        this.stateCodes = [];
                        return [3 /*break*/, 28];
                    case 28:
                        this.formOtherCard.controls['state'].patchValue(null);
                        this.stateCodes.forEach(function (item) {
                            _this.stateOptions.push({
                                text: item.state,
                                value: item.code
                            });
                        });
                        return [3 /*break*/, 30];
                    case 29:
                        if (this.formOtherCard.controls['state']) {
                            this.formOtherCard.controls['state'].patchValue(null);
                            this.formOtherCard.controls['state'].clearValidators();
                            this.formOtherCard.controls['state'].updateValueAndValidity();
                        }
                        this.stateCodes = [];
                        this.showStateField = false;
                        _g.label = 30;
                    case 30:
                        this.formOtherCard.controls['adress'].setValidators(Validators.required);
                        this.formOtherCard.controls['city'].setValidators(Validators.required);
                        this.formOtherCard.controls['zip_code'].setValidators(Validators.required);
                        this.formOtherCard.controls['adress'].updateValueAndValidity();
                        this.formOtherCard.controls['city'].updateValueAndValidity();
                        this.formOtherCard.controls['zip_code'].updateValueAndValidity();
                        if (this.addressInput) {
                            this.addressInput.nativeElement.disabled = false;
                        }
                        if (this.zipCodeInput) {
                            this.zipCodeInput.nativeElement.disabled = false;
                        }
                        if (this.cityInput) {
                            this.zipCodeInput.nativeElement.disabled = false;
                        }
                        _g.label = 31;
                    case 31: return [2 /*return*/];
                }
            });
        });
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_printNumberEnding = function (card) {
        return '**** **** **** **** ' + card.endingAt;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_selectCard = function (card) {
        if (card) {
            this.activeCardType = this.isFOPTypeBancontact() ? 'bancontact' : undefined;
            this.selectedCard = card;
            this.selectedCardType = card.status;
            this.INDRA_checkIfCVCApplicable(card.brand);
            // get the applicable surcharge percentage from the credit card payment methods
            if ((this.type === 'credit') && this.bookAwardFlights === false && this.isTTT === false) {
                this.INDRA_getApplicableSurcharge();
            }
        }
        else {
            this.activeCardType = this.isFOPTypeBancontact() ? 'bancontact' : this.formOtherCard.controls['card_brand'].value;
            this.selectedCard = undefined;
            this.selectedCardType = 'other';
            // reset only when there is no activeCardType (i.e. first time loading the form, no card_brand value yet)
            if (!this.activeCardType) {
                // reset surcharge
                if (this.surcharge > 0) {
                    this.paymentService.setSurcharge(0);
                }
                this.surcharge = 0;
            }
        }
        if (this.isBrazilMarket)
            this.INDRA_resetPayWithInstallments(true);
        this.paymentService.setSelectedCardType(this.selectedCardType);
        switch (this.selectedCardType) {
            case 'other':
                this.selectedForm = this.formOtherCard;
                break;
            case 'expired':
                this.selectedForm = this.formExpiredCard;
                break;
            case 'available':
                this.selectedForm = this.formAvailableCard;
                break;
            default:
                break;
        }
        if (card) {
            this.observatory.setData('cardNumber', card.number);
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_checkIfCVCApplicable = function (cardBrand) {
        this.cardWithoutCvc = cardBrand ? this.paymentService.cardWithoutCVC.includes(cardBrand) : false;
        if (this.cardWithoutCvc) {
            this.formAvailableCard.controls['security_code'].disable();
            this.formAvailableCard.controls['security_code'].setValue(null);
            this.formExpiredCard.controls['security_code'].disable();
            this.formExpiredCard.controls['security_code'].setValue(null);
            this.formOtherCard.controls['security_code'].disable();
            this.formOtherCard.controls['security_code'].setValue(null);
        }
        else {
            this.formAvailableCard.controls['security_code'].enable();
            this.formExpiredCard.controls['security_code'].enable();
            this.formOtherCard.controls['security_code'].enable();
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_deleteCard = function (card) {
        var _this = this;
        this.store.dispatch(new ConfirmModalActions.PutTitle('Delete Card'));
        this.store.dispatch(new ConfirmModalActions.PutBodyMsg('Are you sure you want to delete this card? You will lose this credit card data!'));
        this.store.dispatch(new ConfirmModalActions.PutOkLabel('Confirm delete'));
        this.modalService.assignComponent(INDRAConfirmModalComponent);
        this.modalService.open();
        this.modalService.isOpen
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (!value) {
                if (_this.okToDelete === 'ok') {
                    var req = {
                        recurringDetailReference: card.recurringDetailReference,
                        merchantAccount: 'TAPFlytap_myb',
                        flyTapId: _this.dataUser ? _this.dataUser.airlineID : ''
                    };
                    _this.payment.INDRA_removeSavedCard(req).subscribe(function (res) {
                        if (res && res.status === '200') {
                            // delete from local variable
                            var filteredCards = _this.availableCards.filter(function (availableCard) { return availableCard.recurringDetailReference !== card.recurringDetailReference; });
                            _this.availableCards = filteredCards;
                            // delete from bfm storage
                            var paymentMethod = _this.bfmStorage.INDRA_getPaymentMethod();
                            if (paymentMethod && paymentMethod.data && paymentMethod.data.storedAdyen &&
                                paymentMethod.data.storedAdyen.details && paymentMethod.data.storedAdyen.details.length > 0) {
                                var filteredStoredDetails = paymentMethod.data.storedAdyen.details.filter(function (storedDetail) {
                                    return storedDetail.RecurringDetail.recurringDetailReference !== card.recurringDetailReference;
                                });
                                paymentMethod.data.storedAdyen.details = filteredStoredDetails;
                                _this.bfmStorage.INDRA_setPaymentMethod(paymentMethod);
                            }
                            if (_this.availableCards.length === 0 || _this.selectedCard === card) {
                                _this.selectedCard = undefined;
                                _this.selectedCardType = 'other';
                            }
                        }
                    });
                }
            }
        });
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_isSelectCard = function (card) {
        return this.selectedCard === card;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_isSelectedCardStatus = function (status) {
        return this.selectedCardType === status;
    };
    /**
     * Returns list of instalment options
     * @returns {Array} of instalment options
     */
    INDRAPaymentMethodCardComponent.prototype.INDRA_getInstallmentsOptions = function () {
        return this.installmentOptions;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_changePayWithInstallments = function (event) {
        this.payWithInstalments = event === 'pay_with_instalments-yes';
        var form = this.selectedCardType === 'other' ? this.formOtherCard : (this.selectedCardType === 'available' ? this.formAvailableCard : null);
        if (form) {
            if (this.payWithInstalments) {
                form.controls['instalments_option'].setValidators(Validators.required);
                form.controls['instalments_option'].updateValueAndValidity();
                form.controls['instalments_cpf'].setValidators(Validators.required);
                form.controls['instalments_cpf'].updateValueAndValidity();
                this.installmentOptions = this.INDRA_setInstallmentOptions();
            }
            else {
                form.controls['instalments_option'].clearValidators();
                form.controls['instalments_option'].updateValueAndValidity();
                form.controls['instalments_cpf'].clearValidators();
                form.controls['instalments_cpf'].updateValueAndValidity();
                form.controls['instalments_option'].patchValue(null);
            }
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_resetPayWithInstallments = function (reverseFormReset) {
        this.payWithInstallmentOptions.forEach(function (option) { return option.selected = false; });
        this.payWithInstalments = false;
        var form = null;
        if (reverseFormReset) {
            form = this.selectedCardType === 'other' ? this.formAvailableCard : (this.selectedCardType === 'available' ? this.formOtherCard : null);
        }
        else {
            form = this.selectedCardType === 'other' ? this.formOtherCard : (this.selectedCardType === 'available' ? this.formAvailableCard : null);
        }
        if (form) {
            form.controls['pay_with_instalments'].patchValue(null);
            form.controls['pay_with_instalments'].updateValueAndValidity();
            form.controls['instalments_option'].clearValidators();
            form.controls['instalments_option'].updateValueAndValidity();
            form.controls['instalments_option'].patchValue(null);
            form.controls['instalments_cpf'].clearValidators();
            form.controls['instalments_cpf'].updateValueAndValidity();
            form.controls['instalments_cpf'].patchValue(null);
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_setInstallmentOptions = function (bookingTotalAmount) {
        // reset value to null
        var form = this.selectedCardType === 'other' ? this.formOtherCard : (this.selectedCardType === 'available' ? this.formAvailableCard : null);
        if (form && form.controls['instalments_option']) {
            form.controls['instalments_option'].patchValue(null);
        }
        var installmentOptions = [];
        var totalAmoutTobePaid = bookingTotalAmount ? bookingTotalAmount : this.bookingCashTotalAmount;
        this.currency = this.currencyService.INDRA_getCurrencySymbol().name;
        for (var i = 2; i <= this.installmentCount; i++) {
            var installmentAmount = (totalAmoutTobePaid / i).toFixed(2);
            var installmentItem = {
                text: i + " x " + installmentAmount + " " + this.currency,
                value: {
                    installmentCount: i.toString() /* , amountPerInstallment: installmentAmount */
                }
            };
            installmentOptions.push(installmentItem);
        }
        return installmentOptions;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_updateInstallmentOptions = function (bookingTotalAmount) {
        this.installmentOptions = this.INDRA_setInstallmentOptions(bookingTotalAmount);
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_printCardAriaLabel = function (card) {
        var statusLabel = '';
        if (card.status === 'available') {
            statusLabel = this.INDRA_getTranslation('shoppingBasket.aria.expiresOn');
        }
        else if (card.status === 'expired') {
            statusLabel = this.INDRA_getTranslation('shoppingBasket.aria.hasExpired');
        }
        return this.cardBrands.get(card.brand) ? this.cardBrands.get(card.brand).name +
            this.INDRA_getTranslation('shoppingBasket.aria.cardEndingIn') +
            card.endingAt + '. ' + statusLabel : '';
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_FormValue = function () {
        var _this = this;
        var data = new DataUserPayment();
        var CARD_NUMBER_VALUE = this.formOtherCard.get('card_number').value;
        var foundMatch = Array.from(this.creditCardList.values()).find(function (item) { return item.brand === _this.activeCardType; });
        data.code = foundMatch ? foundMatch.code : undefined;
        data.merchantAccount = foundMatch ? foundMatch.merchantAccount : undefined;
        data.number = CARD_NUMBER_VALUE;
        data.cvc = this.formOtherCard.get('security_code').value;
        data.expiryMonth = this.formOtherCard.get('expiration_date_month').value.padStart(2, '0');
        data.expiryYear = this.formOtherCard.get('expiration_date_year').value.padStart(4, '20');
        data.givenName = this.formOtherCard.get('first_name').value;
        data.surname = this.formOtherCard.get('last_name').value;
        data.holderName = data.givenName + ' ' + data.surname;
        if (this.isAddressFieldsRequired) {
            data.addressLine = this.formOtherCard.get('adress').value;
            data.postalCode = this.formOtherCard.get('zip_code').value;
            data.cityName = this.formOtherCard.get('city').value;
            data.countryCode = this.formOtherCard.get('country').value;
            data.stateCode = this.stateCodes.length > 0 ? this.formOtherCard.get('state').value : '';
            data.stateValue = this.stateCodes.length > 0 ? this.stateCodes.find(function (x) { return x.code === data.stateCode; }).state : '';
        }
        data.isCCHolderTravel = this.cardholderWillTravel ? 'YES' : 'NO';
        data.moment = Math.random();
        data.ipAddress = this.paymentService.getClientIPAddress();
        if (this.isBrazilMarket) {
            var selectedInstallmentOption = this.formOtherCard.get('instalments_option').value;
            if (selectedInstallmentOption) {
                data.cpf = this.formOtherCard.get('instalments_cpf').value;
                var installmentCount = parseInt(selectedInstallmentOption['installmentCount']);
                var amountPerInstallment = (this.bookingCashTotalAmount / installmentCount).toFixed(2);
                data.numberInstallments = selectedInstallmentOption['installmentCount'];
                data.amountInstallments = amountPerInstallment;
                // data.amountInstallments = selectedInstallmentOption['amountPerInstallment'];
            }
        }
        return data;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_changedCheckBoxTravel = function (event) {
        this.cardholderWillTravel = event === undefined ? undefined : (event === 'cardholder_will_travel-yes' ? true : false);
        this.formOtherCard.controls['cardholder_will_travel'].setValue(this.cardholderWillTravel);
        if (this.cardholderWillTravel !== undefined && this.formOtherCard.valid && this.activeCardType !== undefined) {
            this.paymentService.setFormIsValid(true);
        }
        else {
            this.paymentService.setFormIsValid(false);
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_numericOnly = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            return false;
        }
        return true;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_printTitle = function () {
        if (this.type === 'credit') {
            return this.INDRA_getTranslation('bookingPayment.title.creditCardDetails');
        }
        else if (this.type === 'debit') {
            return this.INDRA_getTranslation('bookingPayment.title.debitCardDetails');
        }
        else if (this.type === 'bancontact') {
            return this.INDRA_getTranslation('bookingPayment.title.paymentWithBancontact');
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_setAvailableCardsOptions = function () {
        var _this = this;
        // get active cards from payment method response
        var paymentMethodResponse = this.bfmStorage.INDRA_getPaymentMethod();
        this.isOCP = paymentMethodResponse.data.cardOcpEnable;
        var activeCards = [];
        var disabledCards = [];
        if (paymentMethodResponse && paymentMethodResponse.data &&
            paymentMethodResponse.data.fops && paymentMethodResponse.data.fops.length > 0) {
            activeCards = this.bookingPaymentService.INDRA_getPaymentMethodCards(paymentMethodResponse.data.fops, this.type, true);
        }
        var cardOptions = [];
        var cardsArray = this.type === 'credit' ? this.cardsType : this.cardsTypeDebit;
        cardsArray.forEach(function (card) {
            // put only active/enabled cards
            if (activeCards.indexOf(card) >= 0) {
                var newCardOption = {
                    label: _this.cardBrands.get(card).name,
                    id: _this.cardBrands.get(card).brand,
                    image: _this.cardBrands.get(card).image,
                    selected: _this.activeCardType === _this.cardBrands.get(card).brand ? true : false
                };
                cardOptions.push(newCardOption);
            }
        });
        this.availableCardBrandOptions = cardOptions;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_returnAvailableCards = function () {
        if (this.type === 'credit') {
            return this.cardsType;
        }
        else if (this.type === 'debit') {
            return this.cardsTypeDebit;
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_setPaymentInfoOnService = function (resetPaymentInfo) {
        if (resetPaymentInfo === void 0) { resetPaymentInfo = false; }
        if (resetPaymentInfo) {
            this.paymentService.setPaymentInfo(null);
        }
        else {
            // Set payment info
            var cardName = void 0;
            if (this.selectedCardType === 'other') {
                cardName = this.formOtherCard.controls['first_name'] + ' ' + this.formOtherCard.controls['last_name'];
                // cardName = this.formOtherCard.controls['name_on_card'];
            }
            else {
                cardName = this.selectedCard.name;
            }
            var paymentInfo = {
                name: cardName,
                time: new Date(),
                status: 'pending',
                method: this.paymentService.getSelectedMethod()
            };
            this.paymentService.setPaymentInfo(paymentInfo);
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_composeCardExpiryDate = function (cardBasicInfo) {
        if (cardBasicInfo && cardBasicInfo.expiryMonth && cardBasicInfo.expiryYear) {
            var expiryMonth = cardBasicInfo.expiryMonth;
            return expiryMonth.padStart(2, '0') + "/" + cardBasicInfo.expiryYear;
        }
        return null;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_checkIfExpired = function (cardBasicInfo) {
        var expired = false;
        if (cardBasicInfo && cardBasicInfo.expiryMonth && cardBasicInfo.expiryYear) {
            var year = new Date().getFullYear() % 100;
            var month = new Date().getMonth();
            if ((parseInt(cardBasicInfo.expiryYear, 10) < year) ||
                (year == cardBasicInfo.expiryYear && parseInt(cardBasicInfo.expiryMonth, 10) < month)) {
                expired = true;
            }
        }
        return expired;
    };
    /**
     *	Gets stored card details from the payment method API call to be displayed as available cards
     *  and to be used for one-click CC payment
     */
    INDRAPaymentMethodCardComponent.prototype.INDRA_getStoredCardDetails = function (paymentMethodObj, merchantAccountParamName) {
        var _this = this;
        var selectedCard = null;
        this.availableCards = [];
        if (paymentMethodObj && paymentMethodObj.storedAdyen && paymentMethodObj.storedAdyen.length > 0) {
            // filter the stored credentials based on merchantAccountParamName (to diffentiate award and commercial flow)
            var adyenStoredCredentials_1 = paymentMethodObj.storedAdyen.filter(function (e) { return e.merchantAccount === merchantAccountParamName; });
            if (adyenStoredCredentials_1 && adyenStoredCredentials_1.length === 1 &&
                adyenStoredCredentials_1[0] && adyenStoredCredentials_1[0].details && adyenStoredCredentials_1[0].details.length > 0) {
                adyenStoredCredentials_1[0].details.forEach(function (storedDetails) {
                    if (storedDetails && storedDetails.RecurringDetail) {
                        var cardNumber = storedDetails.RecurringDetail.card ? storedDetails.RecurringDetail.card.number : '';
                        var cardMatch = Array.from(_this.creditCardList.values()).find(function (item) { return item.variant === storedDetails.RecurringDetail.variant; });
                        var storedCardDetails = {
                            brand: cardMatch ? cardMatch.brand : storedDetails.RecurringDetail.variant,
                            variant: storedDetails.RecurringDetail.variant,
                            number: storedDetails.RecurringDetail.additionalData ?
                                storedDetails.RecurringDetail.additionalData.cardBin.padEnd(16, '0') : '',
                            expire_date: _this.INDRA_composeCardExpiryDate(storedDetails.RecurringDetail.card),
                            name: storedDetails.RecurringDetail.card ? storedDetails.RecurringDetail.card.holderName : '',
                            status: (_this.INDRA_checkIfExpired(storedDetails.RecurringDetail.card)) ? 'expired' : 'available',
                            cardNumber: cardNumber,
                            alias: storedDetails.RecurringDetail.alias,
                            recurringDetailReference: storedDetails.RecurringDetail.recurringDetailReference,
                            shopperReference: adyenStoredCredentials_1[0].shopperReference,
                            paymentMethodVariant: storedDetails.RecurringDetail.paymentMethodVariant,
                            endingAt: cardNumber.slice(-4)
                        };
                        _this.availableCards.push(storedCardDetails);
                    }
                });
            }
        }
        // select 'other' card form if there are no stored card credentials OR if the user is not logged in
        // otherwise set the first item in the available stored cards as the one selected by default
        if ((this.availableCards && this.availableCards.length === 0) || !this.logged_in) {
            this.INDRA_selectCard(); // calling the method without card parameter automatically selects 'other' card
        } /* else {
            this.INDRA_selectCard(this.availableCards[0]);
        } */
    };
    /**
     *	Creates and sets the object to be used in CC one-click payment
     *	based on the stored credit card information by the user.
     */
    INDRAPaymentMethodCardComponent.prototype.INDRA_FormValueOneClickPayment = function () {
        var _this = this;
        var data = new DataUserPayment();
        var CARD_NUMBER_VALUE = this.selectedCard.number.padEnd(16, '0');
        CARD_NUMBER_VALUE = CARD_NUMBER_VALUE.substring(0, 12) + this.selectedCard.cardNumber;
        var foundMatch = Array.from(this.creditCardList.values()).find(function (item) { return item.brand === _this.selectedCard.brand; });
        var cardNameSeparator = this.selectedCard && this.selectedCard.name ? this.selectedCard.name.split(' ') : '';
        data.code = foundMatch ? foundMatch.code : undefined;
        data.merchantAccount = foundMatch ? foundMatch.merchantAccount : undefined;
        data.number = CARD_NUMBER_VALUE;
        data.cvc = this.formAvailableCard.get('security_code').value;
        data.expiryMonth = this.selectedCard.expire_date.substr(0, 2);
        data.expiryYear = this.selectedCard.expire_date.substr(3, 4);
        data.holderName = this.selectedCard.name;
        data.isCCHolderTravel = 'YES';
        data.moment = Math.random();
        if (cardNameSeparator && cardNameSeparator.length > 1) {
            var firstName = cardNameSeparator[0];
            var lastName = cardNameSeparator.splice(1, cardNameSeparator.length).join(' ');
            data.givenName = firstName;
            data.surname = lastName;
        }
        data.ipAddress = this.paymentService.getClientIPAddress();
        if (this.isBrazilMarket) {
            var selectedInstallmentOption = this.formAvailableCard.get('instalments_option').value;
            if (selectedInstallmentOption) {
                data.cpf = this.formAvailableCard.get('instalments_cpf').value;
                var installmentCount = parseInt(selectedInstallmentOption['installmentCount']);
                var amountPerInstallment = (this.bookingCashTotalAmount / installmentCount).toFixed(2);
                data.numberInstallments = selectedInstallmentOption['installmentCount'];
                data.amountInstallments = amountPerInstallment;
                // data.amountInstallments = selectedInstallmentOption['amountPerInstallment'];
            }
        }
        var dataUserPaymentObject = {
            dataUserPayment: data,
            recurringDetailReference: this.selectedCard.recurringDetailReference,
            shopperReference: this.selectedCard.shopperReference
        };
        return dataUserPaymentObject;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_handleBookingTicketConditions = function () {
        this.sidebarService.openSidebar(['booking-ticket-conditions']);
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_trimFieldValue = function (e, formControl) {
        if (formControl) {
            formControl.setValue(e.target.value.replace(/\D/g, '').trim());
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_selectedCard = function (activeCard) {
        var selectedCard = this.availableCardBrandOptions.find(function (card) { return card.id == activeCard; });
        return selectedCard;
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_checkRequiredFields = function (form) {
        if (form.dirty) {
            var controls_1 = form.controls;
            var touched = Object.keys(controls_1).filter(function (control) { return controls_1[control].dirty; });
            var lastField = touched.length ? touched[touched.length - 1] : null;
            if (lastField) {
                for (var field in controls_1) {
                    if (field !== lastField && !controls_1[field].value && !controls_1[field].dirty) {
                        controls_1[field].markAsDirty();
                        controls_1[field].markAsTouched();
                    }
                    else if (field === lastField) {
                        break;
                    }
                }
            }
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_getApplicableSurchargeDisplay = function () {
        var paymentMethod = this.bfmStorage.INDRA_getPaymentMethod();
        this.isOCP = paymentMethod.data.cardOcpEnable;
        if (paymentMethod && paymentMethod.data && paymentMethod.data.fops && paymentMethod.data.fops.length > 0) {
            var fopsWithSurcharge = paymentMethod.data.fops.filter(function (fop) { return PAYMENT_METHOD_CREDIT_CARDS.includes(fop.fopCode) && fop.fee && fop.fee.amount > 0; });
            if (fopsWithSurcharge.length > 0) {
                this.surchargeDisplay = fopsWithSurcharge[0].fee.amount;
            }
        }
    };
    INDRAPaymentMethodCardComponent.prototype.INDRA_gotoURL = function (key) {
        var languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
        var languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
        var marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
        var urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
        var urlNavigate = urlIbeAdmin.replace('${lang}', "" + languageMap).replace('${market}', "" + marketCode);
        return window.open(urlNavigate);
    };
    return INDRAPaymentMethodCardComponent;
}());
export { INDRAPaymentMethodCardComponent };
